import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { OrderLineStatus } from "@/types/service/cart/shared";

type Props = {
    statuses: Array<OrderLineStatus>;
};

const CnCOrderItemStatus = ({ statuses }: Props) => {
    const { t } = useGranite();

    return (
        <>
            {statuses.map((status, index) => {
                const params = [];
                if (status.quantity) {
                    params.push(status.quantity);
                }
                return (
                    <div key={index}>
                        {t(
                            `general.orderlinestatus.${status.orderStatus}`,
                            ...params
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default CnCOrderItemStatus;
